import { notification } from 'antd';

export const checkConnection = async () => {
  const isOnline = navigator.onLine;
  
  try {
    // Method 1: Navigator API (less accurate but instant)
    let navigatorSpeed = null;
    if ("connection" in navigator) {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      navigatorSpeed = connection.downlink;
    }

    // Method 2: Download test (more accurate but takes a moment)
    const measureDownloadSpeed = async () => {
      // Using jQuery as a test file (about 300KB)
      const fileUrl = 'https://cdn.jsdelivr.net/npm/jquery@3.6.4/dist/jquery.min.js';
      const measurements = [];
      
      // Perform 3 measurements
      for (let i = 0; i < 3; i++) {
        const startTime = performance.now();
        try {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
          
          const response = await fetch(fileUrl + '?t=' + Date.now(), {
            signal: controller.signal,
            cache: 'no-store',  // Ensure we don't use cached responses
            mode: 'cors'
          });
          
          if (!response.ok) throw new Error('Network response was not ok');
          
          const data = await response.arrayBuffer();
          clearTimeout(timeoutId);
          
          const endTime = performance.now();
          const durationInSeconds = (endTime - startTime) / 1000;
          const fileSizeInBits = data.byteLength * 8;
          const speedInMbps = (fileSizeInBits / durationInSeconds) / 1_000_000; // Convert to Mbps
          
          if (speedInMbps > 0) {
            measurements.push(speedInMbps);
          }
          
          // Add a small delay between measurements
          await new Promise(resolve => setTimeout(resolve, 500));
          
        } catch (error) {
          console.error(`Speed test attempt ${i + 1} failed:`, error);
          continue;
        }
      }
      
      // Calculate average speed from successful measurements
      if (measurements.length > 0) {
        // Remove outliers
        measurements.sort((a, b) => a - b);
        // Remove highest and lowest values if we have at least 3 measurements
        const validMeasurements = measurements.length >= 3 
          ? measurements.slice(1, -1) 
          : measurements;
        
        const avgSpeed = validMeasurements.reduce((a, b) => a + b, 0) / validMeasurements.length;
        console.log('Individual measurements (Mbps):', measurements);
        return avgSpeed;
      }
      
      return null;
    };

    const measuredSpeed = await measureDownloadSpeed();
    // console.log(`Navigator API Speed: ${navigatorSpeed?.toFixed(2)} Mbps`);
    console.log(`Measured Download Speed: ${measuredSpeed?.toFixed(2)} Mbps`);

    // Use measured speed if available, fall back to navigator speed
    const finalSpeed = measuredSpeed || navigatorSpeed;

    // Show warning if speed is too slow (less than 1.5 Mbps)
    if (finalSpeed < 1.0 && isOnline) {
      notification.warning({
        message: 'Slow Internet Connection',
        description: 'Your internet connection appears to be slow. Some features may take longer to load.',
        duration: 5,
      });
    }

    return {
      isOnline,
      speed: finalSpeed,
      isSlow: finalSpeed !== null ? finalSpeed < 1.5 : false
    };

  } catch (error) {
    console.error("Error checking connection:", error);
    return {
      isOnline,
      speed: null,
      isSlow: false
    };
  }
}; 